<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'空间管理系统'" ></detailBread>
       <div class="container">
            <div class="page-title">
                空间管理系统
            </div>
            <div class="page-content">
                <img src="../../../static/images/kjgl1.png" style="margin-bottom: 20px;"/>
                <img src="../../../static/images/kjgl2.png" />
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '空间管理系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '空间管理系统'
        },
        {
            name: 'description',
            content: '空间管理系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'2'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',2)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/kjglxt.vue